import { api } from './apiClient';

/**
 * Project Command Center / workspace-360 / portfolio / EVM analytics client.
 * Backed by /project-analytics + the finance/procurement/billing links on
 * /projects (migration 061). apiClient auto-unwraps {status,data}.
 */

export interface ProjectHealth {
  band: 'ON_TRACK' | 'WATCH' | 'AT_RISK' | 'CRITICAL' | string;
  score: number | null;
  signals: Array<{ dimension: string; state: string; detail: string }>;
}

export interface ProjectCommandCenter {
  kpis: Record<string, any>;
  projects: Array<Record<string, any>>;
  attention: Array<{ severity: string; label: string; link?: string | null }>;
  insights: Array<{ label: string } | string>;
}

export const projectAnalyticsService = {
  commandCenter: (): Promise<ProjectCommandCenter> => api.get('/project-analytics/command-center'),
  project360: (id: number): Promise<any> => api.get(`/project-analytics/project/${id}/360`),
  portfolio: (params?: Record<string, any>): Promise<{ projects: any[]; count: number; groups: any }> =>
    api.get('/project-analytics/portfolio', { params }),
  myDay: (): Promise<any> => api.get('/project-analytics/my-day'),

  // ---- Finance / procurement / billing links (on /projects) ----
  costLedger: (id: number): Promise<any> => api.get(`/projects/${id}/cost-ledger`),
  procurement: (id: number): Promise<any> => api.get(`/projects/${id}/procurement`),
  billing: (id: number): Promise<any> => api.get(`/projects/${id}/billing`),
  createFromSalesOrder: (salesOrderId: number): Promise<any> =>
    api.post(`/projects/from-sales-order/${salesOrderId}`, {}),
};

export default projectAnalyticsService;
